import { api } from './axios';
import type {
  IndividualEntry,
  CreateIndividualEntryRequest,
  UpdateIndividualEntryRequest,
} from '../types/individualEntry';

export const individualEntryApi = {
  findByCategory: (categoryId: number) =>
    api
      .get<IndividualEntry[]>(`/admin/categories/${categoryId}/individual-entries`)
      .then((r) => r.data),

  findById: (id: number) =>
    api.get<IndividualEntry>(`/admin/individual-entries/${id}`).then((r) => r.data),

  create: (categoryId: number, req: CreateIndividualEntryRequest) =>
    api
      .post<IndividualEntry>(`/admin/categories/${categoryId}/individual-entries`, req)
      .then((r) => r.data),

  update: (id: number, req: UpdateIndividualEntryRequest) =>
    api.put<IndividualEntry>(`/admin/individual-entries/${id}`, req).then((r) => r.data),

  remove: (id: number) =>
    api.delete<void>(`/admin/individual-entries/${id}`).then(() => undefined),

  drawStartNumbers: (categoryId: number) =>
    api
      .post<IndividualEntry[]>(
        `/admin/categories/${categoryId}/individual-entries/draw-start-numbers`,
      )
      .then((r) => r.data),
};
